import Vue from 'vue'
import { Button, Image as VanImage, Tab, Tabs, Swipe, SwipeItem, Dialog } from 'vant'

Vue.use(Button)
Vue.use(VanImage)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Dialog)